import React from "react";

import FormCard from "@/components/formInputFields/FormCard";
import FormInput from "@/components/formInputFields/FormInput";
import FormPricingInput from "@/components/formInputFields/FormPricingInput";
import FormSelect from "@/components/formInputFields/FormSelect";
import FormCheckbox from "@/components/formInputFields/FormCheckbox";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";

const DiscountBasicSection = ({ register, errors }) => {
  return (
    <FormCard className="w-full max-w-3xl">
      <FormSectionTitle>Discount Details</FormSectionTitle>

      {/* Discount Name */}
      <FormInput
        label="Discount Name"
        name="discountName"
        placeholder="Enter discount name"
        register={register}
        error={errors.discountName}
        required
      />

      {/* Discount Type */}
      <FormSelect
        label="Discount Type"
        name="discountType"
        register={register}
        error={errors.discountType}
        required
        options={[
          { value: "percentage", label: "Percentage" },
          { value: "fixed", label: "Fixed Amount" },
        ]}
      />

      {/* Discount Value */}
      <FormPricingInput
        label="Discount Value (%)"
        name="discountValue"
        prefix="%"
        placeholder="0"
        register={register}
        error={errors.discountValue}
        required
      />

      {/* Discount Code */}
      <FormInput
        label="Discount Code"
        name="discountCode"
        placeholder="Enter discount code"
        register={register}
        error={errors.discountCode}
        required
      />

      {/* Auto-apply Checkbox */}
      <FormCheckbox
        label="Auto-apply discount code"
        name="autoApplyDiscount"
        register={register}
        error={errors.autoApplyDiscount}
      />
    </FormCard>
  );
};

export default DiscountBasicSection;